<template>
    <el-row class="warp">
        <el-col :span="24" class="warp-main" v-loading="loading" element-loading-text="拼命加载中">
            <!--工具条-->
            <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
                <el-form :inline="true" ref="filters">

                    <el-form-item label="商品名称">
                        <el-input placeholder="名称" style="min-width: 120px" v-model="name"></el-input>
                    </el-form-item>
                    <el-form-item label="商品分类" v-if="editFormVisible == false">
                        <select-tree ref="selectTree" :treeList="returnDropList" nodeKey="treeid" :defaultData="defaultData"
                            :treeProps="treeProps" @handleNodeClick="selectDrop"></select-tree>
                    </el-form-item>
                    <el-form-item label="是否新品">
                        <el-select v-model="sortid" clearable filterable placeholder="请选择">
                            <el-option v-for="item in BrandList" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" @click="handleSearch()">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="add()">增加</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="success" @click="promotion()">关联专题页</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="resetForm('filters')">重置</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
            <!--列表-->
            <el-table :data="pros" highlight-current-row v-loading="loading" border style="width: 100%"
                @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column label="序号" type="index" :index="indexMethod"></el-table-column>
                <el-table-column label="封面图" prop="picurl">
                    <template slot-scope="scope">
                        <div class="demo-image__preview">
                            <el-image style="width: 60px; height: 40px" :src="scope.row.picurl">
                            </el-image>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="商品名称" prop="name" min-width="180"></el-table-column>
                <el-table-column label="所属分类" prop="catename" min-width="100"></el-table-column>
                <el-table-column label="商品ID" prop="id" min-width="60"></el-table-column>
                <el-table-column label="排序" prop="sortid" min-width="80"></el-table-column>
                <el-table-column label="上架" prop="on_off_status" min-width="80">
                    <template slot-scope="scope">
                        <el-tooltip :content="scope.row.on_off_status == 1 ? '上架' : '下架'" placement="top">
                            <el-switch v-model="scope.row.on_off_status <= 1"
                                @change="controlSwitch($event, scope.row, scope.$index)" active-color="#13ce66"
                                inactive-color="#d2d2d2">
                            </el-switch>
                        </el-tooltip>
                    </template>

                </el-table-column>
                <!-- <el-table-column label="工艺" prop="technology" min-width="180"></el-table-column>
                <el-table-column label="材质" prop="material" min-width="250">
                </el-table-column> -->
                <el-table-column label="更新时间" prop="updatetime" min-width="120" :formatter="formatTime"></el-table-column>
                <el-table-column label="操作" fixed="right" min-width="120">
                    <template slot-scope="scope">
                        <el-button type="text" @click="showEditDialog(scope.$index, scope.row)">修改</el-button>
                        <el-button type="text" @click="showSpecDialog(scope.$index, scope.row)">规格编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-col :span="24" class="toolbar">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
                    :page-sizes="[10, 20, 50]" :page-size="10" layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </el-col>


            <!-- 修改页面 -->
            <el-dialog title="编辑" :visible.sync="editFormVisible" center :close-on-click-modal="false">
                <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
                    <el-tabs :tab-position="'top'" v-model="activeIndex" label-position="top">
                        <el-tab-pane label="基本信息" name="0">
                            <el-row :gutter="10">
                                <el-col :span="8">
                                    <el-form-item label="商品名称" prop="name">
                                        <el-input v-model="editForm.name"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <!-- <el-form-item label="商品分类" prop="categoryid">
                                                                                    <el-select v-model="selectTree" clearable filterable placeholder="请选择商品分类">
                                                                                        <el-option :value="selectTree" :label="selectName" style="height: auto">
                                                                                            <el-tree :data="treeData" ref="tree" :props="defaultProps" node-key="id"
                                                                                                :accordion="true" highlight-current :default-checked-keys="checktreeid"
                                                                                                @node-click="handleNodeClick"></el-tree>
                                                                                        </el-option>
                                                                                    </el-select>
                                                                                </el-form-item> -->
                                    <el-form-item label="商品分类" v-if="editFormVisible">
                                        <select-tree ref="selectTree" :treeList="returnDropList" nodeKey="treeid"
                                            :defaultData="defaultData1" :treeProps="treeProps"
                                            @handleNodeClick="selectDrop1"></select-tree>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="10">
                                <el-col :span="8">
                                    <el-form-item label="是否上架" prop="on_off_status">
                                        <el-tooltip :content="editForm.on_off_status == 1 ? '上架' : '下架'" placement="top">
                                            <el-switch v-model="editForm.on_off_status" active-color="#13ce66"
                                                inactive-color="#d2d2d2" :active-value="1" :inactive-value="2">
                                            </el-switch>
                                        </el-tooltip>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="排序" prop="sortid">
                                        <el-input v-model="editForm.sortid" type="number"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="10">
                                <el-col :span="8">
                                    <el-form-item label="材质" prop="material">
                                        <el-input v-model="editForm.material"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="工艺" prop="technology">
                                        <el-input v-model="editForm.technology"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="10">
                                <el-col :span="8">
                                    <el-form-item label="面料" prop="fabric">
                                        <el-input v-model="editForm.fabric"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="填充物" prop="filler">
                                        <el-input v-model="editForm.filler"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="10">
                                <el-col :span="8">
                                    <el-form-item label="缩略图" prop="picurl">
                                        <el-upload class="avatar-uploader" action="/mallapi/MallApi/file/upload"
                                            :show-file-list="false" :on-success="handleAvatarSuccess"
                                            :before-upload="beforeAvatarUpload">
                                            <img v-if="editForm.picurl" :src="editForm.picurl" class="avatar">
                                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                            <div class="el-upload__tip" slot="tip" style="font-weight: bold">图片只能是 JPG
                                                格式，且不超过2M
                                            </div>
                                        </el-upload>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-tab-pane>
                        <el-tab-pane label="商品详情" name="3">
                            <el-form-item label="详情图片" prop="imgurl">
                                <el-upload action="/mallapi/MallApi/file/upload" list-type="picture-card"
                                    :file-list="fileList" :on-success="handlePictureCardPreview" :on-remove="handleRemove"
                                    :before-upload="beforePictureUpload">
                                    <i class="el-icon-plus"></i>
                                    <div class="el-upload__tip" slot="tip" style="font-weight: bold">大小不超过500KB</div>
                                </el-upload>
                                <el-dialog :visible.sync="dialogVisible">
                                    <img width="100%" :src="editForm.imgurl" alt="" />
                                </el-dialog>
                            </el-form-item>
                            <el-form-item prop="content" label="商品详情">
                                <el-card>
                                    <!-- <quill-editor v-model="editForm.content" ref="myQuillEditor"
                                                                                                            :options="editorOption">
                                                                                                            l-editor></quill-editor> -->
                                    <template>
                                        <div v-if="editFormVisible" style="border: 1px solid #ccc;">
                                            <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor"
                                                :defaultConfig="toolbarConfig" :mode="mode" />
                                            <Editor style="height: 500px; overflow-y: hidden;" v-model="editForm.content"
                                                :defaultConfig="editorConfig" :mode="mode" @onCreated="onCreated" />
                                        </div>
                                    </template>
                                </el-card>
                            </el-form-item>
                        </el-tab-pane>
                    </el-tabs>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click.native="editFormVisible = false">取消</el-button>
                    <el-button type="primary" @click.native="editSubmit" :loading="addLoading">提交</el-button>
                </div>
            </el-dialog>


            <!-- 规格页面 -->
            <el-dialog title="规格编辑" :visible.sync="specFormVisible" center :close-on-click-modal="false">
                <el-form label-width="80px">
                    <el-row :gutter="10">
                        <el-form-item>
                            <el-button type="success" @click="addDomain">新增规格</el-button>
                            <el-button type="info" @click="showdetail()">生成规格明细</el-button>
                            <el-button type="warning" @click="defaultNow()">重置规格</el-button>
                        </el-form-item>
                    </el-row>
                    <el-row :gutter="10">
                        <el-form ref="specForm" :inline="true" :model="specmodel" :rules="domainsrules">
                            <el-row v-for="(domain, index) in specmodel.domains" :key="index">
                                <el-form-item :prop="'domains.' + index + '.name'" :label="'规格'" :rules="domainsrules.name">
                                    <el-input v-model="domain.name" placeholder="输入规格名"></el-input>
                                </el-form-item>
                                <el-form-item :prop="'domains.' + index + '.value'" :rules="domainsrules.value">
                                    <el-input v-model="domain.value" placeholder="输入规格值(以中文逗号隔开)"></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button @click.prevent="removeDomain(domain)">删除</el-button>
                                </el-form-item>
                            </el-row>
                        </el-form>

                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="8"> <el-button type="danger" icon="el-icon-delete" @click="proSpec()"
                                v-if="isshow">批量删除</el-button></el-col>
                        <el-table v-if="isshow" :data="tableData" @selection-change="handleSelectionChangeSpec"
                            style="width: 100%" border>
                            <el-table-column type="selection" width="55"></el-table-column>
                            <el-table-column type="index" label="序号"></el-table-column>
                            <el-table-column v-for="(item, index) in columns" :key="index" :label="item.label"
                                :prop="item.prop"></el-table-column>
                            <el-table-column prop="stock" label="库存">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.stock"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="price" label="价格">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.price"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="itemno" label="货号">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.itemno"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="库存更新时间" width="200px" v-if="shownow">
                                <template slot-scope="scope">
                                    <el-input readonly v-model="scope.row.updatetime"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <el-button @click.native="deleteSpec(scope.$index, scope.row)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-row>

                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click.native="specFormVisible = false">取消</el-button>
                    <el-button type="primary" @click.native="specSubmit" :loading="specLoading">提交</el-button>
                </div>
            </el-dialog>

            <!-- 专题页 -->
            <el-dialog title="设置关联" :visible.sync="dialogFormVisible" width="30%">
                <el-form :model="form" ref="proform" :rules="formrules" show-overflow-tooltip>
                    <el-form-item label="专题页" prop="promotionid">
                        <el-select v-model="form.promotionid" clearable filterable placeholder="请选择专题页">
                            <el-option v-for="item in promotionList" :key="item.id"
                                :label="'ID:' + item.id + '*' + '时间:' + dateFormat(item.updatetime, 'yyyy-MM-dd HH:mm:ss')"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click.native="ProSubmit" :loading="proLoading">确 定</el-button>
                </div>
            </el-dialog>

        </el-col>
    </el-row>
</template>

<script>







import MallApi from "../../../api/goods/goodsapi"
import moment from 'moment';
import Api from "../../../api/goods/goodscateapi"
import axios from 'axios'
import selectTree from '@/components/common/selectTree'
import ProApi from "../../../api/goods/promotionapi"

import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { IEditorConfig } from '@wangeditor/editor'
import '@wangeditor/editor/dist/css/style.css'
//import func from 'vue-editor-bridge';

export default {
    name: 'FuncFormsEdit',
    components: {
        Editor, Toolbar, selectTree
    },
    data() {
        return {
            defaultData1: {
                treeid: "-1",
                name: '根目录'
            },

            BrandList: [{ id: 1, name: "新品" }],

            proLoading: false, //专题页确定按钮
            dialogFormVisible: false,//专题页弹框
            form: {
                promotionid: ''
            },//专题页id
            formrules: {
                promotionid: [{ required: true, message: '专题页ID不能为空!', trigger: 'change' }],
            },
            multipleSelection: [],//选中的值
            multipleSelectionSpec: [], //规格选中 

            promotionList: [],//专题页列表
            //搜索框
            defaultData: {
                treeid: "-1",
                name: '根目录'
            },
            treeProps: {
                children: 'children',
                label: 'name'
            },
            returnDropList: [],



            //树目录默认选中值
            checktreeid: [],

            //富文本编辑器字段
            editor: null,
            html: '<p>hello</p>',
            toolbarConfig: {
                excludeKeys: [
                    'fullScreen',//不显示全屏
                    'insertVideo',//不显示插入视频
                ]
            },
            editorConfig: {
                placeholder: '请输入内容...',
                MENU_CONF: {
                    // 配置上传图片
                    uploadImage: {
                        customUpload: this.uploadImageMe // this.uploadImageMe 是 methods 中的一个普通方法
                    },
                }
            },
            mode: 'default', // or 'simple'

            cateid: 0,
            sortid: "",
            name: "",
            flag: "1",
            fileList: [],
            editorOption: {},
            activeIndex: 0,
            loading: false,
            total: 0,
            page: 1,
            limit: 10,
            pros: [],
            editFormVisible: false,
            editForm: {},
            editFormRules: {
                name: [{ required: true, message: "请输入商品名称", trigger: "blur" }],
                categoryid: [{ required: true, message: "请选择商品分类", trigger: "blur" }],
                picurl: [{ required: true, message: "请上传商品缩略图", trigger: "blur" }],
                imgurl: [{ required: true, message: "请上传详情图片", trigger: "blur" }],
                material: [{ required: true, message: "请输入商品材质", trigger: "blur" }],
                technology: [{ required: true, message: "请输入商品工艺", trigger: "blur" }],
                fabric: [{ required: true, message: "请输入商品面料", trigger: "blur" }],
                filler: [{ required: true, message: "请输入商品填充物", trigger: "blur" }],
                content: [{ required: true, message: "请输入商品详情", trigger: "blur" }]
            },

            dialogVisible: false,
            //商品分类
            select: {},
            treeData: [],
            selectTree: "",
            selectName: "",
            defaultProps: { label: "name", children: "children" },

            //提交按钮状态
            addLoading: false,


            //规格
            specFormVisible: false,
            specForm: {},
            specLoading: false,


            //规格生成规则
            specmodel: {
                domains: [],
            },
            domainsrules: {
                name: [{ required: true, message: '规格名不能为空!', trigger: 'blur' }],
                value: [{ required: true, message: '规格值不能为空!', trigger: 'blur' }]
            },

            //规格明细
            tableData: [],
            isshow: false,
            //规格列名
            columns: [],

            //是否显示存库更新时间
            shownow: true,

        };

    },
    methods: {
        //单选赋值
        handleSelectionChangeSpec(val) {
            this.multipleSelectionSpec = val;
        },
        //批量删除
        proSpec() {
            if (this.multipleSelectionSpec.length === 0) {
                this.$message.error({
                    showClose: true,
                    message: "至少选中一个规格哦",
                    duration: 2000,
                });
                return;
            } else {
                this.$confirm("确认删除选中规格吗", "提示", { type: "warning" })
                    .then(() => {
                        var ids = []
                        //循环push
                        this.multipleSelectionSpec.forEach((item, index) => {
                            if (item.id == undefined) {
                                var nowIndex = this.tableData.findIndex(v => v.key === item.key)
                                this.tableData.splice(nowIndex, 1)
                            } else {
                                ids.push(item.id)
                            }
                        })
                        if (ids.length > 0) {
                            //参数
                            let param = {
                                goodsids: ids
                            }
                            //批量删
                            this.delSpec(param)
                        }
                    })
                    .catch(() => { });
            }
        },
        //规格详情删除(单个)
        deleteSpec: function (index, row) {
            //var s = Object.assign({}, row);
            //console.log(s)
            //参数
            var ids = []
            ids.push(row.id)
            let param = {
                goodsids: ids
            }
            //console.log(param)
            this.$confirm("确认删除该规格吗", "提示", { type: "warning" })
                .then(() => {
                    if (row.id == undefined) {
                        this.tableData.splice(index, 1)
                    } else {
                        this.delSpec(param)
                    }
                })
                .catch(() => { });
        },

        //规格删除Api
        delSpec: function (param) {
            let that = this
            MallApi.deletespec(param).then(function (result) {
                if (0 === result.code) {
                    that.$message.success(result.message)
                    that.specDetail()
                } else {
                    that.$message.error({
                        showClose: true,
                        message: result.message || "操作失败",
                        duration: 2000,
                    });
                }
            });

        },
        //序号
        indexMethod(index) {
            return (index + 1) + (this.page - 1) * (this.limit)
        },
        //时间格式转化
        dateFormat(dateData) {
            var date = new Date(dateData);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? "0" + m : m;
            var d = date.getDate();
            d = d < 10 ? "0" + d : d;
            var H = date.getHours();
            H = H < 10 ? "0" + H : H;
            var ms = date.getMinutes()
            ms = ms < 10 ? "0" + ms : ms;
            var s = date.getMilliseconds()
            s = s < 10 ? "0" + s : s;
            const time = y + "-" + m + "-" + d + " " + H + ":" + ms + ":" + s;
            return time;
        },

        //单选赋值
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        //点击专题页
        promotion() {
            if (this.multipleSelection.length === 0) {
                this.$message.error({
                    showClose: true,
                    message: "至少选中一个商品哦",
                    duration: 2000,
                });
                return;
            } else {
                this.dialogFormVisible = true
                this.handlePro()
            }
        },
        //关联专题页保存
        ProSubmit: function () {
            this.$refs['proform'].validate((valid) => {
                if (valid) {
                    //参数
                    let goodsid = []
                    this.multipleSelection.forEach((item, index) => {
                        goodsid.push(item.id)
                    })
                    let param = {
                        promotionid: this.form.promotionid,
                        goodsid: goodsid
                    }
                    //状态修改
                    this.proLoading = true
                    let that = this
                    ProApi.savegoods(param).then(function (result) {
                        if (0 === result.code) {
                            that.proLoading = false
                            that.$message.success(result.message)
                            that.dialogFormVisible = false
                            that.search()
                        } else {
                            that.$message.error({
                                showClose: true,
                                message: result.message || "操作失败",
                                duration: 2000,
                            });
                        }
                    });
                }
            })

        },
        //加载专题页列表
        handlePro() {
            let that = this;
            ProApi.listpros().then(function (result) {
                if (0 === result.code) {
                    that.promotionList = result.data;
                } else {
                    that.$message.error({
                        showClose: true,
                        message: result.msg || "操作失败",
                        duration: 2000,
                    });
                }
            });
        },

        formatTime(row, column) {
            let date = row[column.property];
            if (date === undefined) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD HH:mm:ss")
        },

        handleCurrentChange(val) {
            this.page = val;
            this.search();
        },
        handleSizeChange(val) {
            this.limit = val;
            this.search();
        },
        handleSearch() {
            this.total = 0;
            this.page = 1;
            this.search();
        },
        search: function () {
            let params = {
                pageNum: this.page,
                pageSize: this.limit,
                name: this.name,
                cateid: this.cateid,
                sortid: this.sortid,
            };

            this.loading = true

            let that = this
            MallApi.list(params)
                .then(
                    function (result) {
                        that.loading = false;
                        if (result && result.data.totalSize) {
                            that.total = result.data.totalSize;
                            that.pros = result.data.content;
                        } else {
                            that.total = 0;
                            that.pros = null;
                        }
                    },
                    function (err) {
                        that.loading = false;
                        that.$message.error({
                            showClose: true,
                            message: err.toString(),
                            duration: 2000,
                        });
                    }
                )
                .catch(function (error) {
                    that.loading = false;
                    console.log(error);
                    that.$message.error({
                        showClose: true,
                        message: "请求出现异常",
                        duration: 2000,
                    });
                });
        },
        resetForm(formName) {
            this.name = ''
            this.cateid = 0
            this.sortid = ''
            this.$refs.selectTree.clearSelect()
        },

        //上架状态
        controlSwitch(val, row, index) {     //val 表示v-model的值  row表示这一行，index表示该行的索引
            this.$confirm('确认要操作当前此条数据吗?', "警告",
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    if (row.on_off_status <= 1) {
                        row.on_off_status = 2
                    } else {
                        row.on_off_status = 1
                    }
                    let that = this
                    //this.$set(this.pros, index, row)
                    //that.loading = true;
                    MallApi.upordown({ goodsid: row.id, state: row.on_off_status })
                        .then(function (result) {
                            that.loading = false;
                            if (result && parseInt(result.code) === 0) {
                                that.$message.success({
                                    showClose: true,
                                    message: "操作成功",
                                    duration: 1500,
                                });
                                that.$set(this.pros, index, row)
                            } else {
                                that.$message.error({
                                    showClose: true,
                                    message: result.message,
                                    duration: 1500,
                                });
                            }
                        })
                })
                .catch(() => { });


        },
        //添加
        add() {
            this.$router.push("/mall/goods/add");
        },
        //修改页面
        showEditDialog: function (index, row) {
            this.Tree()
            this.checktreeid = []
            this.editFormVisible = true;
            this.editForm = Object.assign({}, row);

            //树目录选中
            this.selectTree = this.editForm.categoryid
            this.selectName = this.editForm.catename
            this.checktreeid.push(this.editForm.categoryid)

            //new
            this.defaultData1.treeid = this.editForm.categoryid
            this.defaultData1.name = this.editForm.catename
            console.log(this.editForm)
            console.log(this.defaultData1)
            if (this.$refs.selectTree) {
                this.$nextTick(() => {
                    this.$refs['selectTree'].setEdit(this.defaultData1)
                })
            }

            //this.$nextTick(() => {
            //    this.$refs.tree.setCheckedKeys(this.checktreeid)
            //})



            //图片列表回显
            this.fileList = []
            if (this.editForm.imgurl != null && this.editForm.imgurl.length > 0) {
                this.editForm.imgurl.forEach(item => {
                    let obj = new Object();
                    obj.url = item;
                    this.fileList.push(obj);
                });
            }
        },
        //编辑保存
        editSubmit: function () {
            this.$refs['editForm'].validate((valid) => {
                if (valid) {
                    let that = this;
                    this.addLoading = true;
                    console.log(this.editForm)
                    MallApi.update(this.editForm)
                        .then(
                            function (result) {
                                that.addLoading = false;
                                if (result) {
                                    that.$message.success(result.message);
                                    that.$refs["editForm"].resetFields();
                                    that.editFormVisible = false;
                                    that.handleSearch();
                                    that.editForm = {}
                                }
                            },
                            function (err) {
                                that.addLoading = false;
                                that.$message.error({
                                    showClose: true,
                                    message: err.toString(),
                                    duration: 2000,
                                });
                            }
                        )
                        .catch(function (error) {
                            that.loading = false;
                            console.log(error);
                            that.$message.error({
                                showClose: true,
                                message: "请求出现异常",
                                duration: 2000,
                            });
                        });
                } else {
                    this.$message.error("有必填项为空，请检查");
                    return false;
                }

            })
        },
        //商品分类树结构
        Tree() {
            let params = {
                name: null,
                brandid: null
            };
            let that = this;
            Api.getTree(params).then(function (result) {
                if (result.code == 0) {
                    that.treeData = result.data;
                    that.returnDropList = result.data
                }
            },
                function (err) {
                    that.loading = false;
                    that.$message.error({
                        showClose: true,
                        message: err.toString(),
                        duration: 2000,
                    });
                })
        },
        //树目录选择
        handleNodeClick(data) {
            this.editForm.categoryid = data.id; //给表单数据项赋值
            this.selectTree = data.id;
            this.selectName = data.name; // 框中显示值为label
        },

        //实现单选
        handleCheckChange(data, checked) {

            console.log(data)
            //console.log(checked)
        },



        //缩略图上传
        handleAvatarSuccess(res) {
            if (res.code === 0) {
                this.editForm.picurl = "data:image/jpeg;base64," + res.data
            } else {
                this.$message.error(res.message)
            }
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isJPG) {
                this.$message.error('上传头像图片只能是 JPG 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
        },

        //详情图片上传
        handleRemove(file) {
            // this.editForm.imgurl.pop(file.response.data);
            this.editForm.imgurl.splice(this.editForm.imgurl.indexOf(file.url), 1)
            //this.editForm.imgurl.pop(file.url)
        },
        beforePictureUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 <= 500;
            if (!isJPG) {
                this.$message.error('上传图片只能是 JPG 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 500KB!');
            }
            return isJPG && isLt2M;
        },
        handlePictureCardPreview(file) {
            this.editForm.imgurl.push("data:image/jpeg;base64," + file.data);
            this.dialogVisible = false;
        },





        //规格页面
        showSpecDialog: function (index, row) {
            //先重置表格
            this.defaultNow()

            this.specFormVisible = true //规格页显示
            this.shownow = true //库存更新时间显示
            this.specForm = Object.assign({}, row)

            //请求接口获取规格详情及数据
            this.specDetail()
        },

        specDetail: function () {
            this.isshow = true
            let that = this
            let params = { goodsid: this.specForm.id }
            MallApi.spec(params)
                .then(
                    function (result) {
                        that.loading = false;
                        if (result.code == 0) {
                            that.columns = result.data.col
                            that.tableData = result.data.data;
                        }
                    },
                    function (err) {
                        that.loading = false;
                        that.$message.error({
                            showClose: true,
                            message: err.toString(),
                            duration: 2000,
                        });
                    }
                )
                .catch(function (error) {
                    that.loading = false;
                    console.log(error);
                    that.$message.error({
                        showClose: true,
                        message: "请求出现异常",
                        duration: 2000,
                    });
                });

        },

        //规格保存
        specSubmit: function () {
            //规格明细判断（必须大于1）
            if (this.tableData.length == 0) {
                this.$message.error("请至少添加一种商品规格")
                this.activeIndex = "1"
                return
            }

            //规格，规格明细赋值
            let ruForm = {}
            ruForm.id = this.specForm.id
            ruForm.detail = this.tableData
            ruForm.spec = this.specmodel.domains


            let that = this;
            this.specLoading = true;
            MallApi.updatespec(ruForm)
                .then(
                    function (result) {
                        that.specLoading = false;
                        if (result) {
                            that.$message.success(result.message);
                            that.specFormVisible = false;
                            that.handleSearch();
                        }
                    },
                    function (err) {
                        that.specLoading = false;
                        that.$message.error({
                            showClose: true,
                            message: err.toString(),
                            duration: 2000,
                        });
                    }
                )
                .catch(function (error) {
                    that.specLoading = false;
                    console.log(error);
                    that.$message.error({
                        showClose: true,
                        message: "请求出现异常",
                        duration: 2000,
                    });
                });


        },


        //规格明细表格生成
        showdetail() {
            //有规格才能添加
            if (this.specmodel.domains.length == 0) {
                this.$message.error("您暂未添加规格，无法生成明细");
                return
            }

            //表格验证
            this.$refs['specForm'].validate((valid) => {
                //验证通过
                if (valid) {
                    //*****************生成表单数据并展示
                    this.isshow = true
                    this.shownow = false

                    //1.------表头生成
                    this.columns = [] //表头清空
                    this.specmodel.domains.forEach((item, index) => {
                        let col = { 'label': item.name, 'prop': 'name' + index }
                        this.columns.push(col);
                    })

                    //2.------数据生成
                    this.tableData = []
                    let arr = []
                    this.specmodel.domains.forEach(item => {
                        if (item.value != null && item.value != "") {
                            //英文逗号自动转化
                            if (item.value.indexOf(",") > -1) {
                                item.value = item.value.replace(/,/g, "，")
                            }
                            let arry = item.value.split('，');
                            arr.push(arry)
                        }
                    })
                    console.log(arr)
                    let data = this.multiplyData(arr)   //排列组合
                    //console.log(data)

                    if (data.length > 0) {
                        data.forEach((item, index) => {
                            //table数据赋值
                            var info = {}
                            this.columns.forEach((o, dex) => {
                                info[o.prop] = item[dex]
                            })
                            info.stock = 0
                            info.price = 0
                            info.itemno = ''
                            info.key = index
                            this.tableData.push(info)
                        })
                    }
                } else {
                    //this.$message.error("有必填项为空，请检查");
                    return
                }
            })
        },
        //重置规格
        defaultNow() {
            this.specmodel.domains = []
            this.columns = []
            this.isshow = false
            this.tableData = []
        },
        //规格新增
        addDomain() {
            this.specmodel.domains.push({
                name: '',
                value: '',
                key: Date.now()
            });
        },
        //规格删除
        removeDomain(item) {
            var index = this.specmodel.domains.indexOf(item)
            if (index !== -1) {
                this.specmodel.domains.splice(index, 1)
            }
        },

        multiplyData(newArrData) {
            let len = newArrData.length;
            // 当数组长度大于等于2时
            if (len >= 2) {
                // 第一个数组的长度
                let len1 = newArrData[0].length;
                // 第二个数组的长度
                let len2 = newArrData[1].length;
                //  申明一个新数组,做数据暂存
                let items = new Array();
                // 申明新数组的索引
                let index = 0;
                // 2层嵌套循环,将组合放到新数组中
                for (var i = 0; i < len1; i++) {
                    for (var j = 0; j < len2; j++) {
                        if (items.length < index + 1) {
                            items.push([])
                        }
                        if (newArrData[0][i] instanceof Array) {
                            items[index] = items[index].concat(newArrData[0][i].concat(newArrData[1][j]));
                        } else {
                            items[index] = items[index].concat([newArrData[0][i], newArrData[1][j]]);
                        }
                        index++;
                    }
                }
                // 将新组合的数组并到原数组中
                let newArr = new Array(len - 1);
                for (let i = 2; i < newArrData.length; i++) {
                    newArr[i - 1] = newArrData[i];
                }
                newArr[0] = items;
                // 执行回调
                return this.multiplyData(newArr);
            } else {
                console.log(newArrData[0]);
                return newArrData[0];
            }
        },

        imgUrlToBase64: (url) => {
            return new Promise((resolve, reject) => {
                if (!url) {
                    reject('请传入url内容');
                }

                if (/\.(png|jpe?g|gif|svg)(\?.*)?$/.test(url)) {
                    // 图片地址
                    const image = new Image();
                    // 设置跨域问题
                    image.setAttribute('crossOrigin', 'anonymous');
                    // 图片地址
                    image.src = url;
                    image.onload = () => {
                        const canvas = document.createElement('canvas');
                        const ctx = canvas.getContext('2d');
                        canvas.width = image.width;
                        canvas.height = image.height;
                        ctx.drawImage(image, 0, 0, image.width, image.height);
                        // 获取图片后缀
                        const ext = url.substring(url.lastIndexOf('.') + 1).toLowerCase();
                        // 转base64
                        const dataUrl = canvas.toDataURL(`image/${ext}`);
                        resolve(dataUrl || '');
                    }
                } else {
                    // 非图片地址
                    reject('非(png/jpe?g/gif/svg等)图片地址');
                }
            });
        },

        onCreated(editor) {
            this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
        },

        //上传文件配置
        uploadImageMe(file, insertFn) {
            // file 即选中的文件
            // 自己实现上传，并得到图片 url alt href
            const isLt2M = file.size / 1024 <= 500;
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 500KB!');
                return;
            } else {
                let name = file.name;
                let suffix = file.type.split("/")[1];
                name = name + '.' + suffix;
                console.log("suffix:" + suffix)
                if (suffix != "jpeg") {
                    this.$message.error("上传图片只能是 JPG 格式!")
                    return
                } else {
                    let formdata = new FormData()
                    formdata.append("file", file)

                    let that = this
                    //上传方法
                    axios.post("/mallapi/MallApi/img/upload", formdata).then(function (res) {
                        console.log('response:', res);
                        console.log(res.data.code)
                        if (res.data.code === 0) {
                            insertFn(res.data.data.url)
                        } else {
                            that.$message.error(res.data.data.message);
                        }
                    })
                }
            }
        },

        //搜索栏分类选中
        selectDrop(data, checked) {
            // console.log(data)
            this.cateid = data
        },
        //修改
        selectDrop1(data, checked) {
            // console.log(data)
            this.editForm.categoryid = data
        }
    },

    mounted() {
        this.handleSearch()

        if (this.$refs.selectTree) {
            console.log(this.$refs.selectTree)
            console.log(this.$refs.selectTree.nodeKey)
            this.$nextTick(() => {
                this.Tree()
            })
        }

    },
    beforeDestroy() {
        const editor = this.editor
        if (editor == null) return
        editor.destroy() // 组件销毁时，及时销毁编辑器
    }
};
</script>

<style scoped></style>
